
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Sparkles, Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import StartupFeatureRequest from '@/components/featuring/StartupFeatureRequest';

const FeaturedStartups = () => {
  const { user } = useAuth();
  const [showRequestForm, setShowRequestForm] = useState(false);

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 to-red-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
            Featured Startups
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover innovative startups founded by young entrepreneurs who are shaping the future
          </p>
        </div>

        <div className="max-w-2xl mx-auto text-center">
          <Card className="border-2 border-dashed border-orange-200 bg-orange-50/50">
            <CardHeader>
              <div className="flex justify-center mb-4">
                <div className="h-16 w-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center">
                  <Rocket className="h-8 w-8 text-white" />
                </div>
              </div>
              <CardTitle className="text-xl text-orange-700">No Featured Startups Yet</CardTitle>
              <CardDescription className="text-orange-600">
                Be the first startup to be featured on our platform!
              </CardDescription>
            </CardHeader>
            
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Featured startups will appear here once they are added to the platform. 
                Showcase your innovative company and attract young talent.
              </p>
              
              {user ? (
                <div className="space-y-3">
                  <p className="text-sm font-medium text-orange-700">
                    Ready to showcase your startup?
                  </p>
                  <Button 
                    onClick={() => setShowRequestForm(true)}
                    className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600"
                  >
                    <Plus className="h-4 w-4 mr-2" />
                    Request to be Featured
                  </Button>
                </div>
              ) : (
                <div className="space-y-3">
                  <p className="text-sm font-medium text-orange-700">
                    Want to feature your startup?
                  </p>
                  <Button variant="outline" asChild className="border-orange-300 text-orange-600 hover:bg-orange-50">
                    <Link to="/auth">
                      <Sparkles className="h-4 w-4 mr-2" />
                      Join Teenvisor
                    </Link>
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-8">
          <Button asChild variant="outline" size="lg">
            <Link to="/startups">
              View All Startups
            </Link>
          </Button>
        </div>
      </div>

      {showRequestForm && (
        <StartupFeatureRequest onClose={() => setShowRequestForm(false)} />
      )}
    </section>
  );
};

export default FeaturedStartups;
